import React from "react";
import { IDialogProps } from "./interfaces/IDialogProps";
import {
  Dialog as MuiDialog,
  DialogContent,
  Divider,
  DialogActions,
  Box,
  DialogTitle,
  Button,
  Typography,
  Theme,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";

export const Dialog: React.FC<IDialogProps> = (props) => {
  const theme = useTheme();
  const isLightMode = theme.palette.mode === "light";
  const {
    open,
    title,
    subtitle,
    hideHeader = false,
    size,
    fullScreen = false,
    hideCloseIcon = false,
    contentWrappedWithForm,
    contentSx,
    actions,
    onClose,
  } = props;

  const generateActions = () => {
    if (actions) {
      return (
        <DialogActions
          sx={{
            marginTop: 0.5,
            backgroundColor: isLightMode ? "#fff" : "#1E1E1E",

          }}
        >
          {actions.map((action) => {
            return (
              <Button
                variant={action.variant}
                type={action.type}
                disabled={action.disabled}
                onClick={action.onClick}
                size="large"
                sx={{
                  display: "flex",
                  marginLeft: "auto",
                  marginY: 2,
                  minWidth: "80px !important",
                  backgroundColor: isLightMode
                    ? "var(--secondary-color)"
                    : "var(--primary-color)",
                  color: isLightMode
                    ? "var(--text-light-color)"
                    : "var(--text-dark-color)",
                  border: isLightMode
                    ? "var(--border-light-color) 1px solid"
                    : "var(--border-dark-color) 1px solid",
                  "&:hover": {
                    backgroundColor: isLightMode
                      ? "var(--secondary-color)"
                      : "var(--tertiary-color)",
                    opacity: isLightMode ? 0.85 : 1,
                    // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                    border: isLightMode
                      ? "var(--border-light-color) 1px solid"
                      : "var(--border-dark-color) 1px solid",
                  },
                }}
              >
                {action.label}
              </Button>
            );
          })}
        </DialogActions>
      );
    }
  };

  const renderForm = () => {
    const actionsButtons = generateActions();
    if (contentWrappedWithForm) {
      return (
        <form onSubmit={contentWrappedWithForm.onSubmit}>
          <DialogContent
            sx={{ ...contentSx, overflowY: "auto", maxHeight: "70vh" }}
          >
            {props.children}
          </DialogContent>
          <Divider />
          {actionsButtons}
        </form>
      );
    }
    return (
      <>
        <DialogContent sx={contentSx}>{props.children}</DialogContent>
        <Divider />
        {actionsButtons}
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return (
    <MuiDialog
      open={open}
      fullScreen={fullScreen}
      // sx={props.dialogStyles}
      // onClose={onClose}
      maxWidth={size}
      fullWidth
      TransitionComponent={fullScreen ? Transition : undefined}
      sx={{
        ...props.dialogStyles,
        "& .MuiDialog-paper": {
          backgroundColor: isLightMode ? "#fff" : "#1E1E1E",
          color: isLightMode ? "#fff" : "#fff",
          "& .MuiDialogContent-root": {
            color: isLightMode ? "#fff" : "#fff",
          },
          "& .MuiTypography-root": {
            color: isLightMode ? "#fff" : "#fff",
          },
        },
      }}
      // PaperProps={{
      //   sx: {
      //     // backgroundColor: '#1E1E1E',
      //     color: '#fff',
      //     '& .MuiInputBase-root': {
      //       color: '#fff',
      //       backgroundColor: '#1E1E1E',
      //     },
      //     '& .MuiInputLabel-root': {
      //       color: '#fff'
      //     },
      //     '& .MuiOutlinedInput-notchedOutline': {
      //       borderColor: 'rgba(255, 255, 255, 0.3)'
      //     },
      //     "& .MuiDialogContent-root":{
      //       backgroundColor: '#1E1E1E',
      //     },
      //     '& .MuiButton-root': {
      //       '&:hover': {
      //         backgroundColor: '#1E1E1E4',
      //         color: '#000'
      //       }
      //     }
      //   }
      // }}
    >
      {!hideHeader && (
        <>
          <DialogTitle
            sx={(theme: Theme) => ({
              background:
                isLightMode
                  ? "var(--secondary-color)"
                  : "#1E1E1E",
              color: isLightMode ? "#fff" : "#fff",
            })}
          >
            <Box
              display="flex"
              justifyContent={"space-between"}
              sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000" }}
            >
              <Typography variant="h3" fontWeight={"bold"}>
                {title}
              </Typography>
              {!hideCloseIcon && (
                <Box sx={{ cursor: "pointer" }} onClick={onClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </Box>
              )}
            </Box>
            <Typography
              variant="body1"
              color={theme.palette.mode === "dark" ? "rgb(38, 38, 38)" : "#fff"}
            >
              {subtitle}
            </Typography>
          </DialogTitle>
          <Divider />
        </>
      )}
      {renderForm()}
    </MuiDialog>
  );
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});
